import * as React from 'react';
import { IFeedProps } from './IFeedPage';
import { TPitchId } from '@company/components/FeedSelect/IFeedSelect';
import { connect } from 'react-redux';
import { userIsCollaborator } from './functions';
import { updateFollowStatus } from '@company/components/FollowCompany/FollowCompany';
import CompaniesPageService from '@services/CompaniesPage.service';
import PostsList from '@company/components/PostsList/PostsList';
import Details from '@company/components/Details/Details';
import WhitepaperComponent from '@company/components/WhitepaperComponent/WhitepaperComponent';
import Documents from '@company/components/Documents/Documents';
import CoverImageComponent from '@company/components/CoverImageComponent/CoverImageComponent';
import NewFeed from '@company/components/NewFeed/NewFeed';
import FeedSelect from '@company/components/FeedSelect/FeedSelect';
import IPost from '@company/components/Post/IPost';
import TradingDetails from '@company/components/TradingDetails/TradingDetails';
import queryString from 'query-string';
import { TReducers } from '@features/reducers';

import * as style from './FeedPageStyles.module.scss'
import * as appStyle from '../../AppStyle.module.scss';

type TFeedState = {
  posts: IPost[];
  isCollaborator: boolean;
  totalCount: number;
  postsPerPage: number;
  pitchId: TPitchId;
  loaded: boolean;
  updateOnly: boolean;
  displayOnePost: boolean;
};

export class FeedPage extends React.PureComponent<IFeedProps, TFeedState> {
  state: TFeedState = {
    posts: [],
    isCollaborator: false,
    totalCount: 0,
    postsPerPage: 10,
    pitchId: this.props.externalForumPitchId || undefined,
    loaded: false,
    updateOnly: false,
    displayOnePost: false,
  };

  componentDidMount() {
    CompaniesPageService.setCompanyId(this.props.companyId);
    if (this.props.userSignedIn) {
      CompaniesPageService.getCollaborators().then((res) => {
        this.setState({
          isCollaborator: userIsCollaborator(this.props.userProfileId, res.data),
        });
      }).catch((error) => {});

      const { conversation_id } = queryString.parse(window.location.search);
      if (conversation_id && !isNaN(conversation_id)) {
        this.getPost(conversation_id);
      } else {
        this.getFeed();
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: IFeedProps) {
    if (this.props.tmp !== nextProps.tmp && this.props.userSignedIn) {
      this.setState({ pitchId: undefined, updateOnly: false, displayOnePost: false }, () => {
        this.getFeed(undefined, undefined, this.state.updateOnly, nextProps);
      });
    }
  }

  getSelectValue = (value: TPitchId & string) => {
    const isUpdate = value === 'update';
    const isGeneral = value === 'general';
    const pitchId = isGeneral ? null : isUpdate ? undefined : value;

    this.setState({ pitchId, updateOnly: isUpdate }, () => {
      this.getFeed(undefined, pitchId, isUpdate);
    });
  }

  getFeed = (perPage: number = this.state.postsPerPage, pitchId: TPitchId = this.state.pitchId,
             updateOnly: boolean = this.state.updateOnly, props: IFeedProps = this.props) => {
    const path = props.tmp === 'discussion' ? 'public' : 'private';
    CompaniesPageService.getFeed(props.companyId, path, pitchId, undefined, perPage, updateOnly).then((res) => {
      this.setState({ posts: res.data.items, totalCount: res.data.total_count, loaded: true });
    });
  }

  getPost = (postId: number) => {
    const path = this.props.tmp === 'discussion' ? 'public' : 'private';
    CompaniesPageService.getPost(postId, path).then((res) => {
      this.setState({ posts: [res.data], displayOnePost: true });
    }).catch(() => {
      window.location.replace(window.location.pathname);
    });
  }

  checkUsersCompanyFollows = () => {
    if (!this.props.isOwner) {
      updateFollowStatus();
    }
  }

  render() {
    const { isAllowed } = this.props;

    return (
      !this.props.externalForum ? (
        <React.Fragment>
          <CoverImageComponent
            editMode={false}
            isSaving={false}
          />
          <div className={style.feedPage}>
            <main className={appStyle.companyMain}>
              <Details
                editMode={false}
                isSaving={false}
                truncated={true}
                isOwner={this.props.isOwner}
                isCreator={this.props.isCreator}
              />
              {
                isAllowed ?
                  !this.canSeeInvestorZone() ? this.renderBlocked() : this.renderPosts()
                :
                  this.renderRestricted()
              }
            </main>
            <aside className={appStyle.sidebar}>
              <TradingDetails userSignedIn={this.props.userSignedIn} />
              <WhitepaperComponent isUsInvestor={this.props.isUsInvestor} userSignedIn={this.props.userSignedIn} />
              <Documents
                isSaving={false}
                editMode={false}
                isOwner={this.props.isOwner}
                isInvestorZone={this.props.tmp === 'investor_zone'}
                hasInvestorAccess={this.props.hasInvestorAccess}
              />
            </aside>
          </div>
        </React.Fragment>
      ) : (
        <div className={style.feedPage}>
          {
            isAllowed ?
              !this.canSeeInvestorZone() ? this.renderBlocked() : this.renderPosts()
            :
              this.renderRestricted()

          }
        </div>
      )
    );
  }

  updatePosts = (data: IPost) => {
    if (data.pitch_id === this.state.pitchId || this.state.pitchId === undefined) {
      this.setState({
        posts: [
          data,
          ...this.state.posts,
        ],
        totalCount: this.state.totalCount + 1,
      });
    }

    this.checkUsersCompanyFollows();
  }

  private renderRestricted() {
    return (
      <div className={style.anonymousContainer}>
        <div className={style.iconContainer}>
          <svg className="svg-icon svg-icon--violet">
            <use xlinkHref="#icon-padlock"/>
          </svg>
        </div>
        <h2>We just need to check we're friends</h2>
        <span className={style.reason}>
          <strong>Bnktothefuture.com</strong> is a community based
          on <strong>trust</strong> and <strong>transparency</strong>.
          {this.canSeeInvestorZone() ?
           ' Please log in in order to participate in the discussion with confidence.' :
           ' Please login or sign up in order to explore investing opportunities.'}
        </span>
        <a className={style.successBtn} href={`/users/sign_in?return_url=${window.location.href}`}>Sign In</a>
        <span className={style.encourage}>
          Don't have an account yet?
        </span>
        <span className={'text-center'}>Get started
          <a className={style.linkBtn} href={`/join?return_url=${window.location.pathname}`}> here </a>
           to become a member of our investor community.
        </span>
      </div>
    );
  }

  private canSeeInvestorZone = (): boolean => {
    const { userSignedIn, isOwner, tmp, isCreator } = this.props;
    if (tmp !== 'investor_zone') {
      return true;
    }

    if (isCreator && !isOwner) {
      this.props.push('/error/403');

      return false;
    }

    return userSignedIn &&
      (this.props.hasInvestorAccess || isOwner || this.state.isCollaborator);
  }

  private renderPosts() {
    const funding = this.props.funding.filter(elem => elem.slug !== undefined);

    return (
      <React.Fragment>
        {(!this.props.externalForum && !this.state.displayOnePost && this.state.loaded) &&
          <React.Fragment>
            <div className={style.filter}>
              <p>Filter:</p>
              <FeedSelect
                funding={funding}
                getSelectValue={this.getSelectValue}
                moreOptions={true}
                tmp={this.props.tmp}
              />
            </div>
            <NewFeed
              funding={funding}
              companyId={this.props.companyId}
              isDiscussion={this.props.tmp === 'discussion'}
              updatePosts={this.updatePosts}
              profileAvatar={this.props.profileAvatar}
              pitchId={this.state.pitchId}
              isOwner={this.props.isOwner}
            />
          </React.Fragment>
        }
        {this.state.displayOnePost
          && <a className={style.onePostLink} href={window.location.pathname}>View entire forum</a>
        }
        {this.state.posts.length === 0 && this.state.loaded ?
          this.renderEmpty() :
          <PostsList
            posts={this.state.posts}
            funding={funding}
            totalCount={this.state.totalCount}
            getFeed={this.getFeed}
            perPage={this.state.postsPerPage}
            profileId={this.props.profileId}
            profileAvatar={this.props.profileAvatar}
            isDiscussion={this.props.tmp === 'discussion'}
            externalForum={this.props.externalForum}
          />
        }
      </React.Fragment>
    );
  }

  private renderBlocked() {
    const link = this.props.livePitch ? `/pitches/${this.props.livePitch}` : `/search/pitches`;

    return (
      <div className={style.blockedContainer}>
        <div className={style.iconContainer}>
          <svg className="svg-icon svg-icon--violet">
            <use xlinkHref="#icon-padlock" />
          </svg>
        </div>
        <div>
          <h4>
            The Investors Zone is restricted to users who have invested in a pitch
            or have purchased shares from this company on the secondary market.
          </h4>
          {/*<h4 className={appStyle.mT2}>
            <a className={style.investLink} href={link}>Invest in this pitch</a> and get access to investors discussion!
          </h4>*/}
        </div>
      </div>
    );
  }

  private renderEmpty() {
    return (
      <div className={style.emptyContainer}>
        <div className={style.iconContainer}>
          <svg className="svg-icon svg-icon--violet">
            <use xlinkHref="#icon-alert"/>
          </svg>
        </div>
        <h3>No discussion here!</h3>
      </div>
    );
  }
}

const mapStateToProps = (store: TReducers) => {
  return {
    funding: store.companyReducer.funding,
    newFunding: store.companyReducer.newFunding,
    livePitch: store.companyReducer.companyDetails.live_pitch,
  };
};

export default connect(mapStateToProps)(FeedPage);
